import { useI18n } from "@core/i18n/i18n";
import { e2eTestId } from "@e2e/test-ids";
import { TooltipButton } from "@ui/components/common/content-with-tooltip";
import { DialogContext, ModalId } from "@ui/components/dialog/dialog-provider";
import React, { useCallback, useContext } from "react";

export const AddPatientButton: React.FC = () => {
	const { format } = useI18n();
	const dialogContext = useContext(DialogContext);

	const onCreatePatientClicked = useCallback(
		() =>
			dialogContext?.openModal(ModalId.AddPatient, {
				contentStyle: { overflowY: "visible" },
			}),
		[dialogContext],
	);

	return (
		<TooltipButton
			tooltipContent={format("tabbar.patients.demoMode.tooltip")}
			tooltipPosition="bottom"
			id="create-patient"
			data-test={e2eTestId.homePage.createPatientButton}
			label={format("home.addPatientButton")}
			onClick={onCreatePatientClicked}
		/>
	);
};
